// Generated by purs version 0.13.8
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var inline = function (dictEq) {
    var go = function (v) {
        if (v instanceof Lunarbox_Data_Dataflow_Expression.Let) {
            var v1 = Lunarbox_Data_Dataflow_Expression.references(v.value1)(v.value3);
            if (v1.length === 1) {
                var go$prime = function (v2) {
                    if (v2 instanceof Lunarbox_Data_Dataflow_Expression.Variable && (Data_Eq.eq(Lunarbox_Data_Dataflow_Expression.eqVarName)(v2.value1)(v.value1) && Data_Eq.eq(dictEq)(v2.value0)(v1[0]))) {
                        return new Lunarbox_Data_Dataflow_Expression.Expression(v2.value0, v.value2);
                    };
                    return v2;
                };
                return Lunarbox_Data_Dataflow_Expression.Expression.create(v.value0)(Lunarbox_Data_Dataflow_Expression.everywhereOnExpression(Data_Function["const"](true))(go$prime)(v.value3));
            };
            return v;
        };
        return v;
    };
    return Lunarbox_Data_Dataflow_Expression.mapExpression(go);
};
var dce = function (dictEq) {
    var go = function (v) {
        if (v instanceof Lunarbox_Data_Dataflow_Expression.Let && Data_Array["null"](Lunarbox_Data_Dataflow_Expression.references(v.value1)(v.value3))) {
            return new Lunarbox_Data_Dataflow_Expression.Expression(v.value0, v.value3);
        };
        return v;
    };
    return Lunarbox_Data_Dataflow_Expression.mapExpression(go);
};
module.exports = {
    inline: inline,
    dce: dce
};
